import { render } from "./Dashboard.vue?vue&type=template&id=1c8eca51"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=1c8eca51&lang=css"
script.render = render

export default script